import { usePermissionsRepository } from '@Hooks/useRepository';
import { UsersRepository } from '@Repositories/Permissions';
import { isOk, useToasts } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useResetUserPassword = (userId: string) => {
    const users = usePermissionsRepository(UsersRepository);
    const { pushAllToasts } = useToasts();

    const { mutateAsync, isPending: resetUserPasswordIsPending } = useMutation({
        mutationFn: () => users.resetUserPassword(userId),
    });

    const resetPasswordHandler = useCallback(async () => {
        const result = await mutateAsync();
        pushAllToasts(result.messages);
        return isOk(result);
    }, [mutateAsync, pushAllToasts]);

    return { resetPasswordHandler, resetUserPasswordIsPending };
};
